import { User } from '../constants'

export const isTutor = (type) => type === 'tutor'
export const isClient = (type) => ['student', 'parent'].includes(type)
export const isAdmin = (type) => type === 'admin'
export const isGuest = (status) => status === User.STATUS.GUEST
export const isVolunteer = (status) => status === User.STATUS.VOLUNTEER

export const isIdleTutor = ({ status, type }) =>
  isTutor(type) && status === User.STATUS.IDLE
